import React, { useState } from 'react';
import { Button } from 'antd';
import { RegName, RegPassword, RegPhone } from '$CONFIG/common/reg';
import { useForm } from "react-hook-form";
import useRegister from '$UTILS/hooks/useRegister';
import { CaptchaIsEnable } from '$UTILS/helpers/CaptchaIsEnable';
import Loading from '@/Loading';
import Captcha from '../Captcha';
import {getAffFromCookie} from "../../actions/util";

const Central = ({ text, title, onBefore, onSuccess, onError, cssStyleConf={} }) => {
	const affiliateCode = getAffFromCookie();
	const [isCaptchaShow, setIsCaptchaShow] = useState(false);

	const { loading, run } = useRegister({ onBefore, onSuccess, onError })
	const { register, handleSubmit, formState: { errors } } = useForm();

	const handleFormSubmit = (data, uuid) => {
		const { username, password, mobile } = data;
		run({
			...{
				username,
				password,
				mobile: `86-${mobile}`,
				affiliateCode,
				challengeUuid: uuid,
			},
		})
	};

	const onSubmit = (data) => {
		const { username } = data;
		console.log('Username:', username);
		
		CaptchaIsEnable(username).then(isCaptchaEnable => {
			console.log('isCaptchaEnable', isCaptchaEnable);
			if (isCaptchaEnable) {
				setIsCaptchaShow(true);
			} else {
				handleFormSubmit(data, '');
			}
		});
	};

	let submitCssStyle = {};
	if (cssStyleConf?.isFullWidthSubmit) {
		submitCssStyle.width = '100%';
	}
	if (cssStyleConf?.submitFontSize) {
		submitCssStyle.fontSize = cssStyleConf.submitFontSize
	}

	return (
		<>
			<section className="central">
				<div className="title">
					<h3>{title}</h3>
				</div>
				<form className="form-wrapper" onSubmit={handleSubmit(onSubmit)}>
					<p className="desc" dangerouslySetInnerHTML={{ __html: text }} />
					<div className="form-block">
						<div className="login-item grid-cols-4">
							<label className="form-label">用户名</label>
							<input type="text" className="input-control col-span-3" maxLength={14} placeholder="请输入用户名" {...register("username", { required: "用户名不可为空", pattern: { value: RegName, message: "用户名必须由 6 － 14 位长度的字母或数字组成，中间不得有读音符号、空格或下划线。" }, onChange: () => { global.globalGtag('Style9_QRP', 'Registration form', 'Username_input', 'input') } })} />
							{errors.username && <label className="error-txt col-span-3 col-start-2">{errors.username.message}</label>}
						</div>
						<div className="login-item grid-cols-4">
							<label className="form-label">密码</label>
							<input type="password" className="input-control col-span-3" maxLength={20} name="password" placeholder="请输入密码" {...register("password", { required: "密码不可为空", pattern: { value: RegPassword, message: '密码必须包含6-14个字符，字符只限于使用字母和数字。（可以包含 ^#$@ 中的特殊字符）' }, onChange: () => { global.globalGtag('Style9_QRP', 'Registration form', 'Password_input', 'input') } })} />
							{errors.password && <label className="error-txt col-span-3 col-start-2">{errors.password.message}</label>}
						</div>
						<div className="login-item grid-cols-4">
							<label className="form-label">手机号码</label>
							<input disabled type="tel" className="input-control disabled" name="phone" value={'+86'}></input>
							<input type="text" className="input-control col-span-2" maxLength={11} name="mobile" id="inputPhone" placeholder="请输入手机号码" {...register("mobile", { required: "手机号码不可为空", pattern: { value: RegPhone, message: '手机号码必须是 11 位长度的数字。' }, onChange: () => { global.globalGtag('Style9_QRP', 'Registration form', 'phone_input', 'input') } })} />
							{errors.mobile && <label className="error-txt col-span-2 col-start-3">{errors.mobile.message}</label>}
						</div>
						<Button style={submitCssStyle} htmlType='submit' className="submit" onClick={() => { global.globalGtag('Style9_QRP', 'Registration form', 'Submit_registration', 'event') }} disabled={loading}>提交</Button>
						{loading && <Loading />}
					</div>
				</form>
			</section>

			{isCaptchaShow && <Captcha
				captchaVisible={isCaptchaShow}
				setCaptchaVisible={(v)=>{setIsCaptchaShow(v)}}
				onLogin={(uuid)=>{
					handleSubmit((data) => handleFormSubmit(data, uuid))();
				}}
			/>}
		</>
	)
}

export default Central